<template>
  <div class="news-list-page">
    <nav-header></nav-header>
    <!-- <section class="main sec-main">
      <div class="list-wrapper">
        <ul class="tab-hd">
          <li v-for="item in tabs" :key="item.newstypeid" @click="tabChange(item.newstypeid)" :class="{'on':tabId==item.newstypeid}">
            {{item.name}}
          </li>
        </ul>
        <ul class="news-list">
          <li class="item-dl" v-for="item in newsList" :key="item.newsid" @click="toDetail(item,1)">
            <div class="item-dt">
              <img :src="item.imageUrlList[0]" alt="" class="cover">
            </div>
            <div class="item-dd">
              <div class="flex">
                <div class="news-title">{{item.title}} </div>
                <mark class="mark" v-if="item.istop">置顶</mark>
              </div>
              <p class="desc">{{item.introduce}}</p>
              <div class="foot">
                <span class="tag">{{item.newsTypeName}}</span>
                <span class="info">阅读量 : {{item.browsecount}} | {{item.addtime}}</span>
              </div>
            </div>
          </li>
          <li v-if="newsList.length==0"><i class="icon-empty"></i></li>
        </ul>
      </div>
      <aside class="aside">
        <h3 class="aside-title">资讯推荐</h3>
        <ul class="aside-list">
          <li class="item-dl" v-for="(item,index) in caseList" :key="index" @click="toDetail(item,2)">
            <div class="item-dt">
              <img :src="item.imageUrlList[0]" alt="" class="cover">
            </div>
            <div class="item-dd">
              <div class="news-title">{{item.title}} </div>
              <div class="foot">
                <time class="time">{{item.addtime}}</time>
                <span class="read">阅读量 : {{item.browsecount}}</span>
              </div>
            </div>
          </li>
          <li v-if="caseList.length==0"><i class="icon-empty"></i></li>
        </ul>
      </aside>
    </section> -->
    <!-- <div class="new-header">
      <div class="header-main main">
        <div class="header-l">
          <span class="logo" @click="$router.push('/')">
            <img src="../../assets/sp_logo.png" alt="">
          </span>
          <ul class="nav-list">
            <li>
              <router-link class="link" tag="span" to="/newsDrafts" active-class="on" >草稿箱</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="sec-main" style="width: 1056px;margin-left: auto;margin-right: auto;">
      <!-- left -->
      <div class="list-wrapper">
        <ul class="tab-hd">
          <li v-for="item in tabs" :key="item.Id" @click="tabChange(item.Id)" :class="{'on':tabId==item.Id}">
            {{item.CategoryName}}
          </li>
        </ul>
        <div>
          <ul class="new-list-box">
            <li v-for="(item,index) in newsList" :key="item.Id">
              <h3 class="new-title" @click="toDetail(item)">{{item.Title}}</h3>
              <div class="new-content" @click="toDetail(item)">
                <div class="new-img" v-if="item.PostImgFileList instanceof Array && item.PostImgFileList.length">
                  <img :src="item.PostImgFileList[0].FileUrl" alt="图" />
                </div>
                <p class="new-paragraph" v-html="item.ShortContent"></p>
              </div>
              <div class="new-fun-box">
                <ul>
                  <li v-for="(items,index) in item.ForumPostTopicList" :key="index">{{items.TopicTitle}}</li>
                </ul>
                <div>
                  <span class="icon-no-praise"  :class="{'icon-yes-praise':item.IsThumbUp}" @click.stop="forumThumbUp(item.Id,index)">{{item.ThumbUpCount || ''}}</span>
                  <span class="icon-comment" @click="toDetail(item)">{{item.CommentCount || ''}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- right -->
      <div class="right-side-bar">
        <!-- top -->
        <div class="right-border-main" v-if="userDetailInfo">
          <div class="user-side">
            <div class="user-top">
              <div class="user-content">
                <div class="user-portrait">
                  <div>
                    <img class="portrait" :src="userDetailInfo.HeaderImgUrl" alt="头像">
                  </div>
                  <img v-if="userDetailInfo.IsBpoOfficial" class="bv" src="@/assets/new/bv.png" alt="图标">
                </div>
                <div class="user-info">
                  <h3 class="user-title">{{userDetailInfo.UserName}}</h3>
                  <img v-if="userDetailInfo.IsBpoMember" src="@/assets/new/vip.png" style="width:20px;height:16px;" alt="vip">
                  <img v-if="userDetailInfo.IsExpert" src="@/assets/new/master.png" style="width:24px;height:14px;" alt="大咖">
                </div>
              </div>
              <div class="link-drafts" @click="linkPage('d')">
                <span>草稿箱</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <ul class="user-center">
              <li style="cursor: pointer;" @click="linkPage('c')">
                <span style="text-align: right">创作</span>
                <span style="text-align: left">{{userDetailInfo.PostCount}}</span>
              </li>
              <li style="cursor: pointer;" @click="linkPage('s')">
                <span style="text-align: right">收藏</span>
                <span style="text-align: left">{{userDetailInfo.CollecCount}}</span>
              </li>
              <li>
                <span style="text-align: right">关注</span>
                <span style="text-align: left">{{userDetailInfo.FocusUserCount}}</span>
              </li>
              <li>
                <span style="text-align: right">粉丝</span>
                <span style="text-align: left">{{userDetailInfo.FansCount}}</span>
              </li>
            </ul>
            <ul class="user-bottom">
              <li @click="doEdit(3)">
                <img src="@/assets/new/icon-xwz.png" alt="写文章">
                <p>写文章</p>
              </li>
              <li @click="doEdit(2)">
                <img src="@/assets/new/icon-twt.png" alt="提问题">
                <p>提问题</p>
              </li>
              <li @click="doEdit(4)">
                <img src="@/assets/new/icon-xqxf.png" alt="心情想法">
                <p>心情想法</p>
              </li>
              <li @click="doEdit(5)">
                <img src="@/assets/new/icon-zytt.png" alt="专业探讨">
                <p>专业探讨</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- bottom -->
        <div class="right-border-main">
          <h4 class="new-hot-title">近期热榜</h4>
          <ul class="new-hot-list">
            <li v-for="(item,index) in hotPostList" :key="index" @click="toDetail(item)">
              <i>{{index+1}}</i>
              <p>{{item.Title}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <gk-footer></gk-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import gkFooter from '@/components/footer.vue'
import {
  newsTypeList,
  newsList,
  hotNewsList,
  newsViewer,
  GetPostCategory,  //选项分类
  GetPostList,      //获取列表
  ForumThumbUp,     //点赞或取消点赞
  GetHotPostList,   //热门帖子
  GetUserForumInfo, //获取右边用户信息
} from '@/scripts/api.js'
import {mapState} from 'vuex'
const BMap=window.BMap;
export default {
  components:{
    NavHeader,
    gkFooter,
  },
  data(){
    return{
      newsList:[],
      pageNum:1,
      pageSize:10,
      total:0,
      loading:false,
      tabs:[],
      tabId:1,
      caseList:[],

      hotPostList: [],      //热门帖子
      userDetailInfo:{},    //右侧用户信息
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  created() {
    this.getTabs();
    this.getCase();
  },
  mounted() {
    this.newsList = []
    this.onScroll();
    this.getHotPostList();
    this.getUserForumInfo();
  },
  methods: {
    //获取坐标
    getTabs(){
      GetPostCategory().then(res=> {
        if(res.Result==1){
          this.tabs=res.Data ||[];
          this.tabChange(this.tabId);
        }
      })
      // newsTypeList().then(r=>{
      //   if(r.Result==1){
      //     this.tabs=r.Data ||[];
      //     this.tabChange(this.tabId);
      //   }
      // })
    },
    //切换平台
    tabChange(id){
      this.tabId=id;
      this.pageNum=1;
      this.loading=false;
      this.newsList=[];
      this.loadData();
    },
    //加载数据
    loadData(){
      if(this.loading==true){
        return;
      }
      this.loading=true;
      GetPostList({
        UserCode: this.userInfo?this.userInfo.UserCode : '',
        PostCategoryId:this.tabId,
        PageNum: this.pageNum,
        PageSize: this.pageSize,
      }).then(r=> {
        if(r.Result==1){
          let list=r.Data.PostList ||[];
          if(this.pageNum==1){
            this.newsList=list;
            //如果是第一页，页面滚动到首屏
            this.$nextTick(()=>{
              document.documentElement.scrollIntoView(true);
            })
          }else{
            this.newsList=this.newsList.concat(list);
          }
          if(this.pageSize==list.length){
            this.loading=false;
            // this.pageNum=r.Data.pageNum+1;
            this.pageNum=this.pageNum+1;
          }
        }
      })







      // newsList({
      //   pageSize:this.pageSize,
      //   pageNum:this.pageNum,
      //   rational:true,
      //   newstypeid:this.tabId,
      // }).then(r=>{
      //   if(r.Result==1){
      //     let list=r.Data.datas ||[];
      //     if(r.Data.pageNum==1){
      //       this.newsList=list;
      //       //如果是第一页，页面滚动到首屏
      //       this.$nextTick(()=>{
      //         document.documentElement.scrollIntoView(true);
      //       })
      //     }else{
      //       this.newsList=this.newsList.concat(list);
      //     }
      //     if(r.Data.pageSize==list.length){
      //       this.loading=false;
      //       this.pageNum=r.Data.pageNum+1;
      //     }
      //   }
      // })
    },
    //滚动加载
    onScroll(){
      let scrollTop=document.documentElement.scrollTop;
      let that=this;
      document.onscroll=function () {
        let clientHeight=document.documentElement.clientHeight;
        let offsetHeight=document.documentElement.offsetHeight;
        let st=document.documentElement.scrollTop;
        let flag=0;//向下滚动时变成1；
        if(st>scrollTop){
          flag=1;
        }else{
          flag=0;
        }
        scrollTop=st;
        if(offsetHeight-clientHeight-50<=st && flag){
          that.loadData();
        }
      }
    },


    // 点赞或取消
    forumThumbUp(id,idx) {
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      ForumThumbUp({
        ContentId:id,
        ContentType: 1,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=> {
        if(res.Result !=1) {
          return this.$toast(res.Message);
        }
        this.newsList[idx].IsThumbUp = !this.newsList[idx].IsThumbUp
        if(this.newsList[idx].IsThumbUp) {
          this.newsList[idx].ThumbUpCount = this.newsList[idx].ThumbUpCount+1
        }else {
          this.newsList[idx].ThumbUpCount = this.newsList[idx].ThumbUpCount-1
        }
      })
    },







    //获取推荐列表
    getCase(){
      hotNewsList({
        pageSize:3,//显示3条推荐
        pageNum:1,
        rational:0,
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data.datas ||[];
          this.caseList=list;
        }
      })
    },
    //打开详情
    toDetail(item){
      this.$router.push({
        path:'/newsDetail',
        query:{
          id:item.Id
        }
      })
      // newsViewer({
      //   newsid:item.newsid,
      // }).then(r=>{
      //   window.open(item.url,'_blank');
      //   if(r.Result==1){
      //     if(type==1){
      //       //资讯列表
      //       this.newsList.forEach(el => {
      //         if(el.newsid==item.newsid){
      //           el.browsecount++
      //         }
      //       });
      //     }else{
      //       //推荐列表
      //       this.caseList.forEach(el => {
      //         if(el.newsid==item.newsid){
      //           el.browsecount++
      //         }
      //       });
      //     }
      //   }
      // })
    },
    // 获取热门帖子
    getHotPostList(){
      GetHotPostList({
        UserCode: '',
        PageNum: 1,
        PageSize: 10
      }).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message)
        }
        this.$nextTick(()=>{
          this.hotPostList = res.Data.PostList
        })
      })
    },
    // 获取右边用户信息
    getUserForumInfo(){
      GetUserForumInfo({
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=>{
        this.userDetailInfo = res.Data
      })
    },
    // 跳转到对应页面
    linkPage(type){
      this.$router.push({
        path:'/newsDrafts',
        query:{
          type:type
        }
      })
    },
    // 跳转编辑页面
    doEdit(type){
      this.$router.push({
        path:'/newsEdit',
        query:{
          id: 0,
          type:type
        }
      })
    },
  },
  destroyed() {
    document.onscroll=null;
  },
}
</script>
<style lang="scss">
.news-list-page{
  padding-top:68px;
  .new-header {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #f75959;
    border-bottom: 1px solid #ccc \0;
    box-shadow: 0 0 20px rgba(8,1,3,0.16);
    .header-main {
      margin: 0 auto;
      height: 68px;
      position: relative;
    }
    .header-l {
      float: left;
      height: 68px;
    }
    .logo {
      float: left;
      width: 131px;
      height: 37px;
      margin-top: 15px;
    }
    .nav-list{
		float:left;
		margin-left: 54px;
		white-space: nowrap;
		li{
			display: inline-block;
			color:#333;
			font-size: 16px;
			margin-right: 40px;
			position: relative;
		}
		.link{
        display:block;
        color:#333;
        height: 68px;
        line-height: 68px;
        position: relative;
        cursor: pointer;
        user-select: none;
        &:after{
          content:'';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0%;
          height: 2px;
          background-color: #f75959;
          transform: translateX(-50%);
          transition: width 0.2s;
        }
        &.on{
          color: #f75959;
        }
        &.on:after{
          width: 100%;
        }
        &:hover{
          color:#f75959;
          &:after{
            width: 100%;
          }
          .sub-nav{
            height: auto;
          }
          .icon-arrow{
            transform: rotate(-180deg);
          }
        }
        .icon-arrow{
          transition: all 0.2s linear;
        }
      }
    }
  }
  .sec-main{
    min-height: 85vh;
    // overflow: hidden;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  .list-wrapper{
    width: 690px;
    float: left;
    .tab-hd{
      height: 40px;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 30px;
      li{
        float: left;
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        position: relative;
        font-size: 16px;
        color: #666;
        cursor: pointer;
        text-align: center;
        margin-right: 10px;
        &:after{
          content:'';
          position: absolute;
          left: 50%;
          bottom: 0px;
          height: 2px;
          width: 0%;
          transform: translateX(-50%);
          transition: all 0.2s linear;
        }
        &.on,&:hover{
          color: #333;
          &:after{
            width: 100%;
            background-color: #f75959;
          }
        }
      }
    }
  }
  .news-list{
    .item-dl{
      background-color: #fff;
      margin-bottom: 30px;
      width: 840px;
      height: 160px;
      cursor: pointer;
      &:hover{
        .cover{
          transform: scale(1.1);
        }
        .news-title{
          color: #f75959;
        }
      }
    }
    .item-dt{
      float: left;
      width: 256px;
      height: 160px;
      background-color: #f9f9f9;
      overflow: hidden;
      .cover{
        display: block;
        width: 100%;
        height: 100%;
        transition: all 0.2s linear;
      }
    }
    .item-dd{
      float: left;
      margin-left: 24px;
      height: 100%;
      width: 560px;
      position: relative;
    }
    .news-title{
      display: inline-block;
      vertical-align: middle;
      max-width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      font-weight: bold;
      font-size: 18px;
      color: #333;
      line-height: 32px;
      margin-bottom: 16px;
    }
    .mark{
      font-size: 12px;
      color: #fff;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      width: 36px;
      line-height: 20px;
      margin-left: 20px;
      margin-top: 6px;
      background: rgba(236,122,45,1);
    }
    .desc{
      font-size: 14px;
      color: #999;
      line-height: 24px;
      height: 72px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .foot{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      overflow: hidden;
    }
    .tag{
      background: rgba(249,249,249,1);
      border: 1px solid #f75959;
      border-radius: 2px;
      padding: 0 6px;
      font-weight: 400;
      color: #f75959;
      line-height: 24px;
      font-size: 12px;
      float: left;
    }
    .info{
      float: right;
      color: #999;
      font-size: 12px;
      line-height: 24px;
    }
  }
  
  .aside{
    float: right;
    width: 320px;
    .aside-title{
      font-size: 18px;
      color: #333;
      line-height: 40px;
      margin-bottom: 20px;
      // text-align: center;
      // font-weight: bold;
      // &:after,&:before{
      //   content: "";
      //   display: inline-block;
      //   vertical-align: middle;
      //   width: 60px;
      //   height: 1px;
      //   background-color: #f75959;
      //   margin: -3px 10px 0;
      // }
    }
    .item-dl{
      background-color: #fff;
      margin-bottom: 30px;
      width: 320px;
      cursor: pointer;
      margin-bottom: 30px;
      &:hover{
        .cover{
          transform: scale(1.1);
        }
        .news-title{
          color: #f75959;
        }
      }
    }
    .item-dt{
      width: 100%;
      height: 190px;
      background-color: #f9f9f9;
      margin-bottom: 10px;
      overflow: hidden;
      .cover{
        display: block;
        width: 100%;
        height: 100%;
        transition: all 0.2s linear;
      }
    }
    .item-dd{
      width: 100%;
      position: relative;
    }
    .news-title{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      font-size: 18px;
      color: #333;
      line-height: 32px;
    }
    .foot{
      overflow: hidden;
      color: #999;
      font-size: 12px;
      line-height: 24px;
    }
    .time{
      float: left;
    }
    .read{
      float: right;
    }
  }
}
.new-list-box {
  > li {
    margin-bottom: 20px;
  }
  .new-title {
    font-size: 22px;
    color: #333333;
    font-weight: bold;
    line-height: 32px;
    margin-bottom: 18px;
    cursor: pointer;
  }
  .new-content {
    display: flex;
    align-items: flex-start;
    // justify-content: space-between;
    cursor: pointer;
    .new-img {
      flex: 0 0 184px;
      height: 106px;
      margin-right: 20px;
      border: 1px solid #f9f9f9;
      background: #f9f9f9;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .new-paragraph {
      font-size: 16px;
      color: #999999;
      line-height: 30px;
      font-weight: 400;
      margin-top: -7px;
      max-height: 113px;
      overflow: hidden;
      display: -webkit-box;
      // text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
    }
  }
  .new-fun-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 16px;
    > ul {
      > li {
        display: inline-block;
        vertical-align: top;
        font-size: 12px;
        line-height: 15px;
        color: #f75959;
        border: 1px solid #f75959;
        padding: 0 6px;
        margin-right: 14px;
      }
    }
    > div {
      span {
        display: inline-block;
        vertical-align: top;
        margin-left: 12px;
        color: #999999;
        font-size: 18px;
        line-height: 22px;
        padding-left: 27px;
        background-repeat: no-repeat;
        background-position: left center;
        min-width: 30px;
        min-height: 22px;
        text-align: center;
      }
      .icon-no-praise {
        background-image: url('~@/assets/new/icon-no-praise.png');
      }
      .icon-yes-praise {
        background-image: url('~@/assets/new/icon-yes-praise.png');
      }
      .icon-comment {
        background-image: url('~@/assets/new/icon-comment.png');
      }
    }
  }
}
.news-list-page {
  .right-side-bar {
    .right-border-main {
      margin-top: 14px;
      margin-bottom: 50px;
      width: 318px;
      min-height: 200px;
      border-radius: 2px;
      -webkit-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      -moz-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      -o-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      box-shadow: 0 0 8px rgba(34, 23, 20, .1);
    }
    .user-side {
      padding: 20px;
      .user-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        min-height: 32px;
        .user-content {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .user-portrait {
            margin-right: 14px;
            position: relative;
            width: 32px;
            height: 32px;
            > div {
              width: 32px;
              height: 32px;
              overflow: hidden;
              border-radius: 50%;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .bv {
              display: block;
              width: 16px;
              height: 16px;
              object-fit: cover;
              position: absolute;
              right: -4px;
              bottom: -4px;
            }
          }
        }
        .user-info {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .user-title {
            max-width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          img {
            display: inline-block;
            vertical-align: top;
            margin-left: 6px; 
          }
        }
        .link-drafts {
          color: #999999;
          font-size: 14px;
          margin-right: -10px;
          font-weight: bold;
          cursor: pointer;
        }
      }
      .user-center {
        background: #f9f9f9;
        min-height: 88px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 4px 0;
        margin-bottom: 30px;
        li {
          flex: 0 0 50%;
          text-align: center;
          font-size: 16px;
          line-height: 40px;
          color: #666666;
          font-weight: 400;
          display: inline-flex;
          justify-content: space-between;
          span {
            flex: 0 0 48%;
          }
        }
      }
      .user-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          flex: 0 0 22%;
          text-align: center;
          cursor: pointer;
          img {
            display: inline-block;
            vertical-align: top;
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-bottom: 5px;
          }
          p {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            font-weight: bold;
          }
          &:first-child:hover {
            p{
              color: #f75959;
            }
          }
          &:nth-child(2):hover {
            p {
              color: #5e65ff;
            }
          }
          &:nth-child(3):hover {
            p {
              color: #76cc7c;
            }
          }
          &:last-child:hover {
            p {
              color: #ff7d00;
            }
          }
        }
      }
    }
    .new-hot-title {
      font-size: 16px;
      color: #666666;
      font-weight: 400;
      padding-left: 44px;
      line-height: 55px;
      height: 55px;
      border-bottom: 1px solid #e5e5e5;
      background-image: url('~@/assets/new/icon-hot.png');
      background-repeat: no-repeat;
      background-position: 19px 15px;
      background-size: 20px 20px;
    }
    .new-hot-list {
      padding: 0 20px 0 10px;
      overflow: hidden;
      li {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        line-height: 24px;
        color: #666666;
        margin: 20px 0;
        cursor: pointer;
        i {
          flex: 0 0 26px;
          text-align: right;
          padding-right: 8px;
          font-size: 16px;
        }
        &:hover {
          color: #f75959;
        }
        &:first-child {
          i {
            color: #F75959;
          }
        }
        &:nth-child(2) {
          i {
            color: #F78659;
          }
        }
        &:nth-child(3) {
          i {
            color: #F7BD59;
          }
        }
      }
    }
  }
}
</style>